import React, { Fragment, useEffect, useState, useContext } from 'react'
import tremApi from '../../../../../../util/tremApi'
import tremSession from '../../../../../../util/tremSession'
import G from '../../../../../../util/globalFunction'
import { serverUrl, serverPrefixUrl } from '../../../../../../config'
import { getFileList, fileUpload, FileUploader } from '../../../../../../util/tremUpload'
import ModalBox, { usePopup } from '../../../../../../components/modalBox'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faTimes} from '@fortawesome/free-solid-svg-icons'
// import Colgroup from 'react-colgroup';
import Cookies from 'js-cookie'
import TF from '../../../../../../util/tremFunction'
import * as R from 'ramda'


export default props =>{
    const params = props.params
    const {setTabMenu} = props
    const[equipAuthData, setEquipAuthData] = useState({data:{
        equipMstr:[],
        authMstr:{},
        authMember:[],
        userSkey:null,
    }})
    const[eduList, setEduList] = useState({eduDataList:[],F_EDU_CNT:0,TOTAL_EDU_CNT:0})
    const[eduPreList, setEduPreList] = useState({eduPreDataList:[], F_PRE_EDU_CNT:0, TOTAL_EDU_CNT:0})
    const[fileList, setFileList] =useState({data:[], attachSkey:''}) //파일 state
    const[btnExist, setBtnExist] = useState({EvidenceAttach:true})
    
    useEffect(() => {
        window.scrollTo(0, 0);
        tremSession.getUserSkey().then(userSkey => {
            if(R.isNil(userSkey)){
                alert(G.t('trem.lang.home.0697'), G.t('trem.lang.home.1137'), ()=>{G.gotoPage('/login')}) /* 로그인 후 이용가능합니다. */
            }else{
                getAuthDetail(userSkey, params.EQUIP_SKEY)
            }
        })
    }
    ,[])
    // 이용권한 페이지 데이터
    const getAuthDetail = (userSkey, EQUIP_SKEY) =>{
        const detailParams = {EQUIP_SKEY}
        tremApi('/r/hm/equipAuth/receive', detailParams)
        .then(data=>{
            setEquipAuthData({...equipAuthData, data})
            if(data.userSkey&&data.authMstr){
                
                let applyQualEd = 'N'
                let applyQualFi = "N"
                if(data.authMstr.APPLY_QUAL){
                    applyQualEd = data.authMstr.APPLY_QUAL.indexOf("ED")>0?"Y":"N"
                    applyQualFi = data.authMstr.APPLY_QUAL.indexOf("FI")>0?"Y":"N" 
                }
                applyQualEd==='Y'&&setUseEduList(data?.userSkey, data?.authMstr?.UA_MSTR_SKEY)
                applyQualFi==='Y'&&setBtnExist({...btnExist, EvidenceAttach:false}) 
            }
        })
    }

    //이용권한 교육 셋팅
    const setUseEduList = (USER_SKEY,UA_MSTR_SKEY ) =>{
        const eduParams = {USER_SKEY, UA_MSTR_SKEY}
        tremApi('/r/hm/equipAuth/edu/list/json', eduParams)
        .then(data=>{
            let F_EDU_CNT = 0
            let TOTAL_EDU_CNT =0
            data.map((obj)=>{
                obj.REPEAT_CNT>obj.RSLT_CNT&&F_EDU_CNT++
                TOTAL_EDU_CNT++
            })

            setEduList({...eduList, eduDataList:data, F_EDU_CNT, TOTAL_EDU_CNT})
            setPreEduList(USER_SKEY, UA_MSTR_SKEY)
        })
    }

    // 선행교육
    const setPreEduList = (USER_SKEY,UA_MSTR_SKEY) =>{
        const eduParams = {USER_SKEY, UA_MSTR_SKEY}
        tremApi('/r/hm/equipAuth/pre/edu/list/json', eduParams)
        .then(data=>{
            let F_PRE_EDU_CNT = 0
            let TOTAL_EDU_CNT = 0
            data.map((obj)=>{
                TOTAL_EDU_CNT++
                obj.COUNT > obj.RSLT_CNT&&F_PRE_EDU_CNT++
            })
            setEduPreList({...eduPreList, eduPreDataList:data, F_PRE_EDU_CNT, TOTAL_EDU_CNT})
            setUserEvidenceAttach(USER_SKEY)
        })
    }

    //증빙서류
    const setUserEvidenceAttach = (USER_SKEY)=>{
        const attachParams = {USER_SKEY, TYPE:"01"}
        tremApi('/r/user/hm/extInfo/json', attachParams)
        .then(data=>{
            const attachSkey = data.length!==0?data[0].ATTACH_SKEY:''
            const fileListParam = {ATTACH_SKEY:attachSkey}
            attachSkey&&tremApi('/attach/retreive_file_list', fileListParam).then(
                (obj)=>
                {
                setFileList({...fileList, data:obj, attachSkey:fileListParam.ATTACH_SKEY})
            })

        })
    }

    const { equipMstr, authMstr, authMember, userSkey} = equipAuthData.data
    const {eduDataList} = eduList
    const {eduPreDataList} = eduPreList

    //교육신청
    const receiveEdu =(eduSkey, EVENT_TYPE)=>{
        
        //장비병행교육
        if(EVENT_TYPE == 'EDU03'){
            setTabMenu(2)
            return false;
        }

        G.gotoPage(`/home/equip/auth/receiveEdu`,
                    {
                        UA_EDU_SKEY:eduSkey,
                        EQUIP_SKEY:equipMstr?.EQUIP_SKEY,
                        USER_SKEY:userSkey
                    }
        )
        
    }

    // 이용권한 신청 팝업 세팅
    const receiveAuthPopupProps = usePopup('trem.lang.home.0806') /* usePopup 이용권한 신청서 첨부 */

    //이용권한 신청Btn Click
    const receiveAuth = () =>{
        receiveAuthPopupProps.setOpen(true)
    }

    // 이용권한 신청 팝업
    const ReceiveAuthPopup = props =>{
        const {open, handleClose} = props

        // const[authPopupState, setAuthPopupState] = useState({
        //     authFormFileList:[], 
        //     submitFile:[],
        //     authFormAttachSkey:'',
        //     submitFileAttachSkey:''
        // })

        // 입력 폼
        const[authFormAttachSkey, setAuthFormAttachSkey] = useState({
            ATTACH_SKEY : authMstr?.ATTACH_SKEY, // 첨부키
            fileList : [], // 첨부파일리스트
            readOnly : true, // 편집(삭제, 업로드) 가능여부
            oneFileOnly : false, // 파일 개수 (업로드 시 사용)
            imageView : false, // 이미지로 조회 여부
            useUploadCallbackFlag : false, // 업로드 콜백 사용여부
            uploadedFlag : false, // 업로드 시 true로 변경됨.
            usedeletedCallbackFlag : false, // 삭제 콜백 사용여부
            deletedFlag : false, // 삭제 시 true로 변경됨.
        })
        
        //신청
        const[submitFileAttachSkey, setSubmitFileAttachSkey] = useState({
            ATTACH_SKEY : "", // 첨부키
            fileList : [], // 첨부파일리스트
            readOnly : false, // 편집(삭제, 업로드) 가능여부
            oneFileOnly : false, // 파일 개수 (업로드 시 사용)
            imageView : false, // 이미지로 조회 여부
            useUploadCallbackFlag : false, // 업로드 콜백 사용여부
            uploadedFlag : false, // 업로드 시 true로 변경됨.
            usedeletedCallbackFlag : false, // 삭제 콜백 사용여부
            deletedFlag : false, // 삭제 시 true로 변경됨.
        })

        const buttons = [
            {
                title:G.t('trem.lang.home.0048'),/* 완료 */
                handler : ()=>{
                    let isOk = false
                    submitFileAttachSkey.ATTACH_SKEY===null||submitFileAttachSkey.ATTACH_SKEY===""
                    ?alert(G.t('trem.lang.home.0807')) /* 이용권한 신청서 파일을 첨부해주세요. */
                    :isOk = true
                    authFormAttachSkey.fileList.length>submitFileAttachSkey.fileList.length
                    ?alert(G.t('trem.lang.home.0808')) /* 이용권한 신청서 파일을 모두 첨부해주세요 */
                    :isOk = true
                    
                    const saveAuthProps = {
                        "UA_MSTR_SKEY"  : authMstr.UA_MSTR_SKEY
                        , "USER_SKEY"   : userSkey
                        , "STATUS"	    : "P"
                        , "USE_TYPE"    : 3
                        , "ATTACH_SKEY" : submitFileAttachSkey.ATTACH_SKEY
                        , "REQUEST_CD"	: authMstr.ACTIVE_MONTH_CNT===true?authMstr.ACTIVE_MONTH_CNT+"M":""
                    }
                    isOk&&tremApi('/r/auth/hm/insertAuthMember',saveAuthProps).then((authSaveResult)=>{
                        //성공이면 닫기
                        if(authSaveResult){
                            alert(G.t('trem.lang.home.0816'))/* 신청되었습니다. */
                            handleClose()
                            getAuthDetail(userSkey, params.EQUIP_SKEY)
                        }
                    }) 
                }
            },
            {
                title:G.t('trem.lang.home.0146'),/* 닫기 */
                handler : () => {
                    handleClose()
                }
            }
        ]
        
        return (
            open && (
                <ModalBox {...props} buttons={buttons} zIndex={6000}>
                   <div className="equip_auth">
                    <h3 className="tt_type1">{G.t('trem.lang.home.0806')}</h3>{/* 이용권한 신청서 첨부 */}
                    <table className="table_type2">
                        <caption>이용권한 신청 팝업 표 - 이용권한 신청서 양식, 첨부파일로 구성</caption>
                         <tbody>
                            <tr className="t_cspan">
                                <th scope='row' style={{width:200}}>{G.t('trem.lang.home.0809')}</th>{/* 이용권한 신청서 양식 */}
                                <td>
                                    <FileUploader 
                                        attachFileInfo={authFormAttachSkey} 
                                        setAttachFileInfo={setAuthFormAttachSkey}
                                    />
                                </td>
                            </tr>
                            <tr className="t_cspan ">
                                <th scope='row' style={{width:200}}>
                                    {G.t('trem.lang.home.0240')}
                                    {/*첨부파일*/}
                                </th>
                                <td>
                                    <FileUploader 
                                        attachFileInfo={submitFileAttachSkey} 
                                        setAttachFileInfo={setSubmitFileAttachSkey}
                                    />
                                </td>
                            </tr>
                         </tbody>
                    </table> 
                    </div>
                </ModalBox>
            )
        )
    }

    // 파일 업로드
    const fileUploadBtn =()=>{
        let fileProps = {ATTACH_SKEY:fileList.attachSkey}
        let create = false
        fileUpload(fileProps).then((obj)=>{
            // attachSkey 가 없으면 생성
            if(fileList.attachSkey ===null || fileList.attachSkey==""){
                fileProps = {ATTACH_SKEY:obj.data.ATTACH_SKEY}
                create = true
                setFileList({...fileList, data:fileList.data ,attachSkey:obj.data.ATTACH_SKEY})
                const userExtinfoParam = {
                    USER_SKEY:userSkey,
                    TYPE:"01",
                    ATTACH_SKEY : obj.data.ATTACH_SKEY
                }
                tremApi(`/user/hm/extInfo/save`,userExtinfoParam).then((result)=>{
                    result&&alert(G.t('trem.lang.home.0810'))/* 증빙자료 정보가 생성되었습니다. */
                })
            }
            // 파일업로드 성공
            if(obj.success){
                create||alert(G.t('trem.lang.home.0811'))/* 파일이 성공적으로 업로드 되었습니다. */
                tremApi('/attach/retreive_file_list', fileProps).then((obj)=>{
                    setFileList({...fileList,data:obj,attachSkey:fileProps.ATTACH_SKEY}) 
                })
            }
        })
    }

    //파일삭제 
    const removeFile = props =>{
        G.confirm(G.t('trem.lang.home.0812')).then(result=> /*첨부된 파일을 삭제하시겠습니까?*/
            result&&tremApi('/attach/delete', {FILE_SKEY:props}).then((obj)=>{
                obj&&setFileList({
                    ...fileList,
                    data:fileList.data.filter(data=> data.FILE_SKEY !==props),
                    attachSkey:fileList.attachSkey
                });  
            }))
    }

    //파일전체 삭제 
    const allRemoveFile = props =>{
        const allDeleteProps = {ATTACH_SKEY:props}
        if(fileList.data.length!==0){
            G.confirm(G.t('trem.lang.home.0813')).then(result=> //첨부된 모든 파일을 삭제하시겠습니까?
                result&&tremApi('/r/attach/delete/all', allDeleteProps).then((obj)=>{
                    obj&&setFileList({
                    ...fileList,
                    data:[],
                    attachSkey:props
                    }); 
                })
            )
        }else{
            alert(G.t('trem.lang.home.0814')) /* 삭제할 첨부파일이 없습니다. */
        }
    }

    // 이용권한 신청2
    const receiveAuth2 = () =>{
        const saveAuthProps = {
            "UA_MSTR_SKEY"  : authMstr.UA_MSTR_SKEY
            , "USER_SKEY"   : userSkey
            , "STATUS"	    : "P"
            , "USE_TYPE"    : 3
            , "REQUEST_CD"	: authMstr.ACTIVE_MONTH_CNT==true?authMstr.ACTIVE_MONTH_CNT+"M":""
        }

        G.confirm(G.t('trem.lang.home.0815')).then(result=> /* 직접이용권한을 신청하시겠습니까? */   
        result&&tremApi('/r/auth/hm/insertAuthMember',saveAuthProps).then((authSaveResult)=>{
            if(authSaveResult){
                alert(G.t('trem.lang.home.0816'))/* 신청되었습니다. */
                getAuthDetail(userSkey, params.EQUIP_SKEY)
            }
        })
        )
        
    }
    // html변환
    const htmlTag = props =>{
        let content = props
        if(content){
            content = content.replaceAll("&gt;", ">");
            content = content.replaceAll("&lt;", "<");
            content = content.replaceAll('&quot;', '"');
            content = content.replaceAll("&#39;", "'");
            content = content.replaceAll("&amp;", "&");
        }
        return content
    }
    const currentLang = Cookies.get('__floor_lang__') || 'ko'
    return (
        <Fragment>  
        <div className="reser_con">
             <div className="q_info">
             <h3 className='hidden'>{G.t('trem.lang.home.0052')}</h3>
                 <ul>
                     <li>
                     <img alt={equipMstr.KOR_NM+" 사진"} src={R.isNil(equipMstr.PHOTO_FILE_SKEY) || equipMstr.PHOTO_FILE_SKEY === 0 ? equipMstr.PHOTO_URL || serverUrl+serverPrefixUrl+"/resources/images/gist/common/no_image.jpg" : TF.getPhotoURL(equipMstr.PHOTO_FILE_SKEY) }/>                     
                     </li>
                     <li>
                         <p>{equipMstr.ENG_NM??G.t('trem.lang.home.0900')}</p>{/* 없음 */}
                         <h3>{equipMstr.KOR_NM??G.t('trem.lang.home.0900')}</h3>{/* 없음 */}
                         <a href="javascript:void(0);" title ="새창" className="btn_help2" style={{top: '70px'}} onClick={() => { TF.goHelp("/hm/manual/equipAuth/receive")}}>도움말</a>
                         <dl>
                         <dt className={currentLang === 'ko' ? "" : "dl_h_en"}>{G.t('trem.lang.home.0711')}</dt> {/* NTIS등록번호 */}
                             <dd className={currentLang === 'ko' ? "" : "dl_h_en"}>{equipMstr.EQUIP_NO??G.t('trem.lang.home.0900')}</dd>{/*없음*/}
                             <dt>{G.t('trem.lang.home.0641')}</dt> {/* 모델명 */}
                             <dd>{equipMstr.MODEL_NM ?? G.t('trem.lang.home.0900')}</dd>{/* 없음 */}
                             <dt>{G.t('trem.lang.home.0640')}</dt> {/* 제조사 */}
                             <dd>{equipMstr.MANUFACTURE_NM ?? G.t('trem.lang.home.0900')}</dd>{/*없음*/}
                             <dt className={currentLang === 'ko' ? "" : "dl_h_en"}>{G.t('trem.lang.home.0712')}</dt> {/* 구축일자 */}
                             <dd className={currentLang === 'ko' ? "" : "dl_h_en"}>{equipMstr.TAKE_DT_STR ?? G.t('trem.lang.home.0900')}</dd>{/*없음*/}
                             <dt>{G.t('trem.lang.home.0630')}</dt> {/* 소속(부서) */}
                             <dd>{equipMstr.DEPT_NAME ?? G.t('trem.lang.home.0900')}</dd>{/* 없음 */}
                             <dt>{G.t('trem.lang.home.0040')}</dt>{/* 담당자 */}
                             <dd>
                                 {equipMstr.MNG_NAME ?? G.t('trem.lang.home.0900')}{/* 없음 */}
                                 {equipMstr.MNG_NAME && equipMstr.MNG_EMAIL&& " / "}
                                 {equipMstr.MNG_EMAIL ?? G.t('trem.lang.home.0900')}{/* 없음 */}
                                 {equipMstr.MNG_NAME && equipMstr.MNG_PHONE_NO&&" / "}
                                 {equipMstr.MNG_PHONE_NO ?? G.t('trem.lang.home.0900')}{/* 없음 */}
                             </dd>
                         </dl>
                     </li>
                 </ul>
             </div>
             {/* 이용권한 신청버튼 */}
             <div  className="btn_type1">
               
                {(()=>{
                    let btnStatus = true
                    if(authMstr){ //Object.keys(authMstr).length!==0
                        let applyQualEd = 'N'
                        let applyQualFi = "N"
                        let eduCntCheck = true // 자격상태 체크

                        if(authMstr.APPLY_QUAL){
                            applyQualEd = authMstr.APPLY_QUAL.indexOf("ED")>0?"Y":"N"
                            applyQualFi = authMstr.APPLY_QUAL.indexOf("FI")>0?"Y":"N" 
                        }
                        if(applyQualEd === "Y") {
                            if(eduList.F_EDU_CNT > 0) {
                                eduCntCheck = false;
                            }
                            if(eduPreList.F_PRE_EDU_CNT > 0) {
                                eduCntCheck = false;
                            }		
                        } else {
                            eduCntCheck = false;
                        }

                        const allTotalEduCnt = eduList.TOTAL_EDU_CNT + eduPreList.TOTAL_EDU_CNT   
                            if(
                                ((applyQualEd === "Y" && applyQualFi === "N") && allTotalEduCnt > 0 && eduCntCheck) ||
                                // 2 : 교육X & 증빙O => 증빙검사통과
                                ((applyQualEd === "N" && applyQualFi === "Y") && fileList.data.length>0) ||
                                // 3 : 교육X & 증빙X
                                (applyQualEd === "N" && applyQualFi === "N") ||
                                // 4-1 : 교육O & 증빙O & 교육수 0초과 => 교육이수검사통과 or 증빙검사통과
                                ((applyQualEd === "Y" && applyQualFi === "Y" && allTotalEduCnt > 0) && (eduCntCheck || fileList.data.length>0)) ||
                                // 4-2 : 교육O & 증빙O & 교육수 0 => 증빙검사통과
                                ((applyQualEd === "Y" && applyQualFi === "Y" && allTotalEduCnt === 0) && fileList.data.length>0)
                            ){
                                btnStatus = false                               
                            }else{
                                btnStatus = true
                            }
                        
                        
                            if(authMember){
                                if(authMember.STATUS==='P'&& authMember.USE_TYPE === '1'){
                                    return <a href="javascript:void(0);" className="btn_type1">{G.t('trem.lang.home.0817')}</a> /* 직접이용권한 신청중. */
                                }else if(authMember.STATUS === 'P' && authMember.USE_TYPE === '3'){
                                    return <a href="javascript:void(0);" className="btn_type1">{G.t('trem.lang.home.0817')}</a> /* 직접이용권한 신청중. */
                                }else if(authMember.STATUS === 'A' && authMember.USE_TYPE === '1' && authMember.EXPIRE_CHECK === 'N'){
                                    return <a href="javascript:void(0);" className="btn_type1">{G.t('trem.lang.home.0818')}</a> /* 직접이용권한 이용중. */
                                }else if(authMember.STATUS === 'A' && authMember.USE_TYPE === '3' && authMember.EXPIRE_CHECK === 'N'){
                                    return <a href="javascript:void(0);" className="btn_type1">{G.t('trem.lang.home.0818')}</a> /* 직접이용권한 이용중. */
                                }else{
                                    return authMstr.ATTACH_SKEY&&authMstr.ATTACH_FILE_COUNT&&authMstr.ATTACH_FILE_COUNT!==0?
                                    btnStatus===false&&<a href="javascript:void(0);" className="red" onClick={()=>receiveAuth(authMstr.ATTACH_SKEY)}>{G.t('trem.lang.home.0726')}</a> // 직접이용권한신청
                                    :btnStatus===false&&<a href="javascript:void(0);" className="red" onClick={()=>receiveAuth2()}>{G.t('trem.lang.home.0726')}</a> //직접이용권한신청
                                }
                            }
                            else{
                                return authMstr.ATTACH_SKEY&&authMstr.ATTACH_FILE_COUNT&&authMstr.ATTACH_FILE_COUNT!==0?
                                btnStatus===false&&<a href="javascript:void(0);" className="red" onClick={()=>receiveAuth(authMstr.ATTACH_SKEY)}>{G.t('trem.lang.home.0726')}</a> //직접이용권한신청
                                :btnStatus===false&&<a href="javascript:void(0);"a className="red" onClick={()=>receiveAuth2()}>{G.t('trem.lang.home.0726')}</a> //직접이용권한신청
                            }
                        }
                })()}
             </div>
             <div><ReceiveAuthPopup {...receiveAuthPopupProps}/></div>

            {/* 이용안내 */}
            {
                authMstr&&authMstr.USE_WAY&&<Fragment>
                    <h5 className="tt_type3">{G.t('trem.lang.home.0694')}</h5>{/* 이용안내 */}
                    <div className="attach_box">
                        <div dangerouslySetInnerHTML={{__html:authMstr.USE_WAY}} className="p-2">
                        </div>
                    </div>
                </Fragment>
            }
            
            {/* 증빙자료 (첨부파일)*/}
            {(()=>
                btnExist.EvidenceAttach===false&&<Fragment>
                <h5 className="tt_type3">
                    {G.t('trem.lang.home.0819')} {/* 증빙자료 */}
                    <a href="javascript:void(0);" className="btn_upload" onClick={fileUploadBtn}>{G.t('trem.lang.home.0107')}</a>{/* 업로드 */}
                </h5>
                <div className="attach_box">
                <ul className="file_attach_box2 flex justify-between p-2">
                        <li className="upload_file_list">
                                {fileList&&fileList.data.map((obj, index)=>{                     
                                    return(
                                        <span key ={index}>
                                            <a href={serverUrl + serverPrefixUrl + "/attach/download?FILE_SKEY="+obj.FILE_SKEY}>
                                            <FontAwesomeIcon icon={faDownload}/>
                                            <em>{obj.REAL_NAME}</em>
                                            </a>
                                            
                                            <FontAwesomeIcon icon={faTimes} title ="삭제" style={{marginLeft:'8px'}} onClick={()=>removeFile(obj.FILE_SKEY)} onKeyDown={(e)=>e.code==="Enter"&&removeFile(obj.FILE_SKEY)} tabIndex={0}/>
                                            
                                        </span>

                                    )
                                    })  
                                }
                        </li>
                        <li>
                            {fileList.data.length===0
                                ? <a href="javascript:void(0);" onClick={()=>alert(G.t('trem.lang.home.0820'))} className="btn_download">{/* 다운로드할 첨부파일이 없습니다. */}
                                    {G.t('trem.lang.home.0105')}{/* 전체 다운로드 */}
                                </a>
                                : <a href={serverUrl + serverPrefixUrl + "/attach/download/all?ATTACH_SKEY="+fileList.attachSkey} className="btn_download">
                                    {G.t('trem.lang.home.0105')}{/* 전체 다운로드 */}
                                </a>
                            }
                            <a href="javascript:void(0);" onClick={()=>allRemoveFile(fileList.attachSkey)} className="btn_delete">
                                {G.t('trem.lang.home.0106')}{/* 전체 삭제 */}
                            </a> 
                        </li>
                    </ul>
                </div>
                </Fragment>
            
            )()
            }

            {eduDataList&&eduDataList.map((obj, index)=>{
                let statusStr = ""
                obj.APPLY_CNT>0?statusStr=G.t('trem.lang.home.0821') /* 예약중 */
                :obj.REPEAT_CNT>obj.RSLT_CNT?statusStr=G.t('trem.lang.home.0822') /* 진행중 */
                :statusStr=G.t('trem.lang.home.0823') /* 수료 */

                let eventName = htmlTag(obj.EVENT_NAME)

                return(
                    <div className="equip_auth" key ={index}>
                        {/* {obj.EVENT_NAME} */}
                    <h3 className="tt_type1" >{eventName}<span className="progress">{statusStr}</span></h3>
                    <table className="table_type4">
                        <caption>교육정보 표 - 교육료, 필요교육횟수, 수료교육횟수로 구성</caption>
                         <tbody>
                             <tr>
                                 <th scope='row'>{G.t('trem.lang.home.0824')}</th> {/* 교육료 */}
                                 <td>
                                    {obj.AMOUNT===true?
                                    `${(new String(obj.AMOUNT)).replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ${G.t('trem.lang.home.0781')}` /*  ~원*/
                                    :G.t('trem.lang.home.0900')}{/* 없음 */}
                                 </td>
                             </tr>
                             <tr>
                                 <th scope='row'>{G.t('trem.lang.home.0825')}</th>{/* 필요 교육횟수 */}
                                 <td>{obj.REPEAT_CNT+G.t('trem.lang.home.0827')}</td> {/* ~ 회*/}
                             </tr>
                             <tr>
                                 <th scope='row'>{G.t('trem.lang.home.0826')}</th> {/* 수료 교육횟수 */}
                                 <td>{obj.RSLT_CNT+G.t('trem.lang.home.0827')}</td> {/* ~ 회*/}
                             </tr>
                         </tbody>
                    </table> 
                    {obj.NOTE&&<p>   
                        <span>{obj.NOTE}</span>
                    </p>
                    }

                    {obj.APPLY_CNT > 0&&<div className="auth_t_box">
                        <p className={"color :red"}>* {G.t('trem.lang.home.0828')}</p> {/* 예약된 교육정보입니다. */}
                        <table className="table_type1">
                            <caption>예약중인 교육 표 - 예약일자, 강사, 전화번호로 구성</caption>
                            <thead>
                                <th scope='col'>{G.t('trem.lang.home.0444')}</th>{/*예약일자*/}
                                <th scope='col'>{G.t('trem.lang.home.0829')}</th>{/*강사*/}
                                <th scope='col'>{G.t('trem.lang.home.0514')}</th>{/* 전화번호 */}
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{`${obj.EDU_RSLT.START_TIME} ~ ${obj.EDU_RSLT.END_TIME}`}</td>
                                    <td>{obj.EDU_RSLT.LECTURER_NAME}</td>
                                    <td>{obj.EDU_RSLT.TEL_NO}</td>
                                </tr>
                                </tbody>
                        </table>
                        </div>

                    }

                    {obj.PRE_CHECK === "N"&&<div className="auth_t_box">
                        <p className={"color :red"}>* {G.t('trem.lang.home.0829')}</p>
                        <table className="table_type1">
                            <caption>선행교육 표 - 유형, 교육명, 교육횟수, 완료여부로 구성</caption>
                            <thead>
                                <tr>
                                    <th scope='col'>{G.t('trem.lang.home.0168')}</th>{/* 유형 */}
                                    <th scope='col'>{G.t('trem.lang.home.0310')}</th>{/* 교육명 */}
                                    <th scope='col'>{G.t('trem.lang.home.0831')}</th>{/* 교육횟수 */}
                                    <th scope='col'>{G.t('trem.lang.home.0832')}</th>{/* 완료여부 */}
                                </tr>
                            </thead>
                            <tbody className="edu_pre_wrap">
                                {obj.PRE_LIST.map((eduPreList, index)=>{
                                    return(
                                    <tr key={index}>
                                        <td>{currentLang === 'ko' ? `${eduPreList.EVENT_TYPE_NAME}[${eduPreList.EVENT_TYPE_NAME}]` : `${eduPreList.EVENT_TYPE_ENG_NAME}[${eduPreList.EVENT_TYPE_ENG_NAME}]`}</td>
                                        <td>{eduPreList.NAME}</td>
                                        <td>{`(${eduPreList.PRE_COMPLETION_TOTAL}/${eduPreList.PRE_COUNT})`}</td>
                                        <td>
                                            {eduPreList.PRE_COMPLETION_CHECK === "Y"
                                                ? G.t('trem.lang.home.0048')/* 완료 */
                                                : G.t('trem.lang.home.0833')/*미완료*/
                                            }
                                        </td>
                                    </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                        </div>
                    }

                    {obj.PRE_CHECK === "Y"&& obj.APPLY_CNT === 0&& 
                        <div className="btn_type1">
                            <a href="javascript:void(0);" className="red" onClick={()=>receiveEdu(obj.UA_EDU_SKEY, obj.EVENT_TYPE)}>{G.t('trem.lang.home.0012')}</a>{/* 교육신청 */}
                        </div>
                    } 
                    </div>  
                )
            })
            }
            {eduPreDataList.length>0&&<Fragment>
                <h3 className="tt_type3 mt-4">{G.t('trem.lang.home.0834')}</h3> {/* 선행교육정보 */}
                <table className="table_type4">
                    <caption>선행교육정보 표 - 교육명, 필요 교육횟수, 수료 교육횟수로 구성</caption>
                    <tbody className="edu_pre_wrap">
                        {eduPreDataList.map((obj,index)=>{
                            return(
                            <Fragment key={index}>
                            <tr >
                                <th scope='row'>{obj.EVENT_NAME}</th>
                                <td>{obj.REFERENCE_NAME}</td>
                            </tr>
                            <tr>
                                <th scope='row'>{G.t('trem.lang.home.0825')}</th>{/* 필요 교육횟수 */}
                                <td>{obj.COUNT+G.t('trem.lang.home.0827')}</td> {/* ~ 회*/}
                            </tr>
                            <tr>
                                <th scope='row'>{G.t('trem.lang.home.0826')}</th> {/* 수료 교육횟수 */}
                                <td >{obj.RSLT_CNT+G.t('trem.lang.home.0827')} {/* ~ 회*/}
                                    <span className="pl-2">
                                        [ {obj.PRE_COMPLETION_CHECK === "Y"
                                            ? G.t('trem.lang.home.0048')/* 완료 */
                                            : G.t('trem.lang.home.0833')/* 미완료 */
                                        } ]
                                    </span>
                                </td>
                            </tr>
                            </Fragment>
                            )
                        })}
                    </tbody>
                </table>
                </Fragment>
            }
         </div>
        </Fragment> 
    )

}